/**
 * Color 선택 Modal
 */

import Vue from 'vue'
import { Sketch } from 'vue-color'

Vue.component('sketch-picker', Sketch)

export default {
  name: 'BriqueChartModalColor',
  inheritAttrs: false, // 부모 Component에서 지정한 Element 속성을 무시 - vue 파일의 다음 구분 참조(v-bind="$attrs", v-on="$listeners"
  props: {
    visible: {
      type: Boolean,
      default: true,
      required: false
    },
    parentChartData: {
      type: Array,
      required: true
    },
    seriesName: {
      type: String,
      default: '',
      required: true
    },
    beforeColor: {
      type: String,
      default: '',
      required: true
    }
  },
  computed: {
  },
  methods: {
    /**
     * 확인 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     */
    onClickConfirmButton (returnObject) {
      this.$emit('click-confirm-button-in-modal-color', returnObject, this.seriesName, this.colors)
    },

    /**
     * 취소 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     */
    onClickCancelButton (returnObject) {
    },

    /**
     * Default Color로 변경
     */
    onClickRestoreDefaultColor () {
      let element = this.$parent.$el.children[0]

      let index = element.data.map(item => item.name).indexOf(this.seriesName)
      let paletteColor = element.layout.colorway[index]

      this.colors = paletteColor
    }
  }, // end - methods
  created () {
  },
  watch: {
    tabStep (strTabStep) {
      this.data.tabStep = this.tabSteps.indexOf(strTabStep)
    },
    visible () {
      if (this.visible === false) return
      this.colors = this.beforeColor
      // y축 초기 세팅
      // let element = this.$parent.$el.children[0]

      // setTimeout(() => {
      // })
    }
  },
  data () {
    return {
      colors: {}
    } // end - data return
  } // end-data
}
